import { render, staticRenderFns } from "./NavigationDropdown.vue?vue&type=template&id=122fe3b6&scoped=true&"
import script from "./NavigationDropdown.vue?vue&type=script&lang=js&"
export * from "./NavigationDropdown.vue?vue&type=script&lang=js&"
import style0 from "./NavigationDropdown.vue?vue&type=style&index=0&id=122fe3b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122fe3b6",
  null
  
)

export default component.exports